import Comp from './index.vue'
Comp.install = Vue => Vue.component(Comp.name, Comp)
export default Comp
